import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics, isSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyBAAbhBuThlYGGtT_ByEdqTWHDs2vJbX88",
  authDomain: "therapist-d62ff.firebaseapp.com",
  projectId: "therapist-d62ff",
  storageBucket: "therapist-d62ff.firebasestorage.app",
  messagingSenderId: "751655387586",
  appId: "1:751655387586:web:2d91f655db54e0609e165b",
  measurementId: "G-5EQ1H1ZRS7"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Initialize Analytics conditionally (only in browser environment)
export const analytics = isSupported().then(yes => yes ? getAnalytics(app) : null);